var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InvoiceStatus',{attrs:{"status":_vm.data.paymentStatus}}),_c('RideList',{attrs:{"data":_vm.data,"drawerType":_vm.drawerType,"filters":_vm.filters},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }